import React from "react";
import "./Header.css";

export function Header() {
  return (
    <header className="protrain-header">
      <div className="protrain-header-left">
        <span className="protrain-header-brand">Nimbus ProTrain</span>
      </div>
      <div className="protrain-header-center">
        <img src="/logo.svg" alt="Nimbus Value logo" className="protrain-header-logo" />
      </div>
      <div className="protrain-header-right" />
    </header>
  );
}
